import axios, { AxiosRequestConfig } from 'axios';

const getApiBaseUrl = () => {
  // 로컬 개발 시 .env.local로 API 대상 강제 지정
  // (dev 서버에 아직 배포되지 않은 API를 테스트할 때 사용)
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  const hostname = window.location.hostname;

  if (hostname === 'kaddie.golf' || hostname === 'www.kaddie.golf') {
    return 'https://api.kaddie.golf/v1/kaddie';
  }

  // 임시: dev kaddie 서버에 shopId 매장 조회가 아직 배포되지 않아(400)
  // dev·로컬도 운영 kaddie API를 사용한다. dev 배포 완료 시 아래로 복원할 것:
  // return 'https://dev-api.kaddie.golf/v1/kaddie';
  return 'https://api.kaddie.golf/v1/kaddie';
};

const API_BASE_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: API_BASE_URL,
  // 응답이 오지 않을 때 무한 대기하지 않도록 상한을 둔다.
  // 주의: 예약 POST의 타임아웃은 "실패"가 아니라 "결과 미확인"이다.
  // 서버가 이미 처리했을 수 있으므로 호출부에서 예약 상태를 다시 조회해 판단해야 한다.
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('customer_token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status ?? 0;
    const normalized = {
      status,
      // 타임아웃은 응답을 못 받았을 뿐 서버 처리 여부는 알 수 없다는 표시
      isTimeout: err.code === 'ECONNABORTED' || err.code === 'ETIMEDOUT',
      message: err.response?.data?.message || err.message || 'Network error',
      details: err.response?.data,
    };
    return Promise.reject(normalized);
  },
);

export const http = {
  get: <T>(url: string, config?: AxiosRequestConfig) => api.get<T>(url, config).then((r) => r.data),
  post: <T, B = unknown>(url: string, body?: B, config?: AxiosRequestConfig) =>
    api.post<T>(url, body, config).then((r) => r.data),
  put: <T, B = unknown>(url: string, body?: B, config?: AxiosRequestConfig) =>
    api.put<T>(url, body, config).then((r) => r.data),
  patch: <T, B = unknown>(url: string, body?: B, config?: AxiosRequestConfig) =>
    api.patch<T>(url, body, config).then((r) => r.data),
  del: <T>(url: string, config?: AxiosRequestConfig) =>
    api.delete<T>(url, config).then((r) => r.data),
};
